import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import Header from "./components/Header";
import HomePage from "./pages/HomePage";
import TechnologyPage from "./pages/TechnologyPage";
import ApplicationsPage from "./pages/ApplicationsPage";
import VisionPage from "./pages/VisionPage";
import CollaborationPage from "./pages/CollaborationPage";
import "./styles/HomePage.css";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Header />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/technology" element={<TechnologyPage />} />
            <Route path="/applications" element={<ApplicationsPage />} />
            <Route path="/vision" element={<VisionPage />} />
            <Route path="/collaboration" element={<CollaborationPage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;

